import React from 'react';
import train from '../assets/img/cwr.jpg';
import sunset from '../assets/img/sunset_beach.jpg';
import aerial from '../assets/img/aerial.jpg';

const HistoryPage = () => {
    return (
        <div className="staticPage">
            <h1>History</h1>
            <p>
                Youth Camps For Christ, Inc. owns and operates Camp Willow
                Springs and Camp Willow Run. Both camps are non-profit,
                interdenominational Christian camps and retreat centers located
                on beautiful Lake Gaston near Littleton, NC.
            </p>
            <img src={aerial} />
            <p>
                In 1967, God gave the late Reverend Erbie Mangum, Jr. and his
                wife, Linda, the vision for starting Christian camps. In 1968,
                the development of Camp Willow Run (CWR) began. The founders
                envisioned camps that would not only offer summer adventures,
                but would also help participants recognize those adventures as
                blessings from God by showing children and youth why, and how,
                to have a relationship with Jesus Christ. CWR has been blessed
                to serve thousands of campers and guests. As a result of CWR’s
                growth and the provision of additional land, the development of
                Camp Willow Springs (CWS) began.
            </p>
            <img src={train} />
            <p>
                Currently, CWS is able to serve up to 120 campers/guests using
                the six completed duplex dormitories, swimming pool complex,
                meeting room/dining room, amphitheater, health care center,
                office, and recreation areas. All dormitories are
                air-conditioned, heated, and equipped with bathrooms. Up to 20
                campers and 2 counselors (summer) or chaperones (retreats) live
                in the duplex dormitories. As development continues, CWS will
                eventually serve over 240 campers/guests.
            </p>
            <img src={sunset} />
            <p>
                The faith that brought CWR into being originated in the hearts
                of the Reverend Erbie W. Mangum, Jr. and his wife, Linda. God
                motivated them and showed them the direction. He also motivated
                hundreds of wonderful and generous people whose time and
                resources actually built Camp Willow Run.
            </p>
            <p>
                On June 16, 1975, death claimed the earthly life of Mr. Mangum.
                In September of 1977, Linda married Robert T. Harris of
                Littleton. She is continuing her work at Youth Camps For Christ
                as Executive Director.
            </p>
        </div>
    );
};

export default HistoryPage;



// WEBPACK FOOTER //
// ./src/pages/history.js